export const PAGOS_RECURRENTES_USER_ID = "66912d4e033ec737ecbc6a15";

export const canAccessPagosRecurrentes = (user) => {
  if (!user) return false;
  if (String(user.id) === PAGOS_RECURRENTES_USER_ID) return true;
  return (user.area || "").toUpperCase() === "ADMINISTRACION";
};
